module.exports = ".table-container {\n  width: 100%;\n  overflow-y: auto;\n  _overflow: auto;\n  margin: 0 0 1em; }\n\n.paddingTop {\n  padding-top: 2em; }\n"